// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg version=%271.1%27 id=%27Слой_1%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 x=%270px%27 y=%270px%27 width=%2718px%27 height=%2718px%27 viewBox=%270 0 18 18%27 style=%27enable-background:new 0 0 18 18;%27 xml:space=%27preserve%27><g>\t<g>\t\t<path d=%27M2,0v18h10.7l3.3-3.3V0H2z M15,14.3L12.3,17H12v-3h3V14.3z M15,13h-4v4H3V1h12V13z M13,3.7L12,3.3L9.3,9.6L5.9,6.1\t\t\tL5.1,6.9l4.5,4.5L13,3.7z%27/>\t</g></g></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,<svg version=%271.1%27 id=%27Слой_1%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 x=%270px%27 y=%270px%27 width=%2718px%27 height=%2718px%27 viewBox=%270 0 18 18%27 style=%27enable-background:new 0 0 18 18;%27 xml:space=%27preserve%27><g>\t<g>\t\t<path d=%27M2,0v18h10.7l3.3-3.3V0H2z M15,14.3L12.3,17H12v-3h3V14.3z M15,13h-4v4H3V1h12V13z M13,3H5v1h8V3z M13,6H5v1h8V6z M13,9H5\t\t\tv1h8V9z%27/>\t</g></g></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;utf8,<svg version=%271.1%27 id=%27Слой_1%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 x=%270px%27 y=%270px%27 width=%2718px%27 height=%2718px%27 viewBox=%270 0 18 18%27 style=%27enable-background:new 0 0 18 18;%27 xml:space=%27preserve%27><g>\t<g>\t\t<path d=%27M11,6h-1v2h1V6z M8,6H7v2h1V6z M11,12h-1v2h1V12z M14,6h-1v2h1V6z M14,9h-1v2h1V9z M14,12h-1v2h1V12z M11,9h-1v2h1V9z\t\t\t M5,12H4v2h1V12z M8,9H7v2h1V9z M5,9H4v2h1V9z M15,3V1h-1v2H4V1H3v2H0v14h18V3H15z M17,16H1V4h16V16z M5,6H4v2h1V6z M8,12H7v2h1\t\t\tV12z%27/>\t</g></g></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;utf8,<svg version=%271.1%27 id=%27Слой_1%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 x=%270px%27 y=%270px%27 width=%2718px%27 height=%2718px%27 viewBox=%270 0 18 18%27 style=%27enable-background:new 0 0 18 18;%27 xml:space=%27preserve%27><g>\t<rect x=%278.5%27 y=%274%27 width=%271%27 height=%276%27/>\t<path d=%27M9,1C4.6,1,1,4.6,1,9c0,4.4,3.6,8,8,8s8-3.6,8-8C17,4.6,13.4,1,9,1z M9,16c-3.9,0-7-3.1-7-7c0-3.9,3.1-7,7-7s7,3.1,7,7\t\tC16,12.9,12.9,16,9,16z%27/>\t<rect x=%278%27 y=%2712%27 width=%272%27 height=%271%27/></g></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2718px%27 height=%2718px%27 fill=%27Black%27><path d=%27M14,14v-1h-1v1H14z M16,14v-1h-1v1H16z M6,14v-1H5v1H6z M10,14v-1H9v1H10z M8,14v-1H7v1H8z M8.6,10h4l4.1-2.1l-0.4-0.8L12.4,9h-4l-4.1,2.1l0.4,0.8L8.6,10z M12,14v-1h-1v1H12z M14,1h-1v1h1V1z M16,1h-1v1h1V1z M12,1h-1v1h1V1z M8,1H7v1h1V1zM6,1H5v1h1V1z M8.6,6h4l4.1-2.1l-0.4-0.8L12.4,5h-4L4.3,7.1l0.4,0.8L8.6,6z M10,1H9v1h1V1z M4,3H3v1h1V3z M17,10h1V9h-1V10zM17,8h1V7h-1V8z M17,12h1v-1h-1V12z M17,14h1v-1h-1V14z M17,6h1V5h-1V6z M17,1v1h1V1H17z M17,4h1V3h-1V4z M4,7H3v1h1V7z M4,1H3v1h1V1z M4,5H3v1h1V5z M4,9H3v1h1V9z M4,13H3v1h1V13z M1,0H0v17h18v-1H1V0z M4,11H3v1h1V11z%27 /></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2718px%27 height=%2718px%27 fill=%27Black%27><path d=%27M8,8V7H7v1H8z M8.6,4h4l4.1-2.1l-0.4-0.8L12.4,3h-4L4.3,5.1l0.4,0.8L8.6,4z M6,8V7H5v1H6z M16,14v-1h-1v1H16zM14,14v-1h-1v1H14z M8.6,11h4l4.1-2.1l-0.4-0.8L12.4,10h-4l-4.1,2.1l0.4,0.8L8.6,11z M10,8V7H9v1H10z M14,8V7h-1v1H14z M16,8V7h-1v1H16z M12,8V7h-1v1H12z M12,14v-1h-1v1H12z M1,0H0v17h18v-1H1V0z M4,13H3v1h1V13z M17,12h1v-1h-1V12z M17,14h1v-1h-1V14zM17,10h1V9h-1V10z M17,7v1h1V7H17z M8,14v-1H7v1H8z M10,14v-1H9v1H10z M4,11H3v1h1V11z M6,14v-1H5v1H6z M4,7H3v1h1V7z M4,9H3v1h1V9z%27 /></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml;utf8,<svg version=%271.1%27 id=%27Слой_1%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 x=%270px%27 y=%270px%27 width=%2718px%27 height=%2718px%27 viewBox=%270 0 18 18%27 style=%27enable-background:new 0 0 18 18;%27 xml:space=%27preserve%27><g>\t<polygon points=%2711,2.3 8.3,8.6 4.9,5.1 4.1,5.9 8.6,10.4 12,2.7 \t%27/>\t<path d=%27M14,2V0H2v16h2v2h7.7l4.3-4.3V2H14z M3,1h10v10H9v4H3V1z M13,12v0.3L10.3,15H10v-3H13z M15,13.3L11.3,17H5v-1h5.7l3.3-3.3\t\tV3h1V13.3z%27/></g></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timerinterval-wrap {
    position: relative;
    z-index: 1000;
    width: 100%;
}

div.preloader {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 100000000;
    background: #8cc7eb;
    pointer-events: none;
    display: flex;
    align-items: center;
    padding: 6px;
    transition: visibility 0s 0.2s, opacity 0.2s;
}

.preloader.show {
    visibility: visible;
    opacity: 0.8;
    transition: visibility 0s 1s, opacity 0.3s 1s;
}

[data-loader="timer"] {
    position: relative;
    width: 24px;
    height: 24px;
    border: 2px solid #fff;
    border-radius: 50%;
    background-color: transparent;
}

    [data-loader="timer"]:after,
    [data-loader="timer"]:before {
        position: absolute;
        content: "";
        background-color: #fff;
    }

    [data-loader="timer"]:after {
        top: 11px;
        left: 11px;
        width: 10px;
        height: 2px;
        -webkit-transform-origin: 1px 1px;
        -moz-transform-origin: 1px 1px;
        transform-origin: 1px 1px;
        -webkit-animation: timerhand 2s linear infinite;
        -moz-animation: timerhand 2s linear infinite;
        animation: timerhand 2s linear infinite;
    }

    [data-loader="timer"]:before {
        top: 11px;
        left: 11px;
        width: 8px;
        height: 2px;
        -webkit-transform-origin: 1px 1px;
        -moz-transform-origin: 1px 1px;
        transform-origin: 1px 1px;
        -webkit-animation: timerhand 8s linear infinite;
        -moz-animation: timerhand 8s linear infinite;
        animation: timerhand 8s linear infinite;
    }

@-webkit-keyframes timerhand {
    0% {
        -webkit-transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
    }
}

@-moz-keyframes timerhand {
    0% {
        -webkit-transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
    }
}

@-o-keyframes timerhand {
    0% {
        -webkit-transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes timerhand {
    0% {
        -webkit-transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
    }
}

.trend {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
}

.trend__container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}

.trend__toolbar {
    position: relative;
    display: flex;
    width: 100%;
    height: 30px;
}

.trend__chart-wrapper {
    position: relative;
}

.trend__chart {
    position: relative;
}

.trend__minilegend {
    position: absolute;
    z-index: 1;
    top: var(--top);
    right: var(--right);
}

.trend__xdatazoom {
    box-sizing: border-box;
    display: flex;
    overflow: unset;
    z-index: 1;
    margin-left: var( --left ); /* чтобы зум начинался откуда же и график начинается */
    width: 100%;
    height: 20px;
}

.trend__ydatazoom {
    box-sizing: border-box;
    top: var(--top);
    right: 0;
    display: flex;
    width: 20px;
    overflow: unset;
    z-index: 1;
}

.trend__minilegend .caption {
    background: darkgray;
    padding: 0.2em;
    user-select: none;
    cursor: all-scroll;
}

.legend {
    display: flex;
    flex-direction: column;
    width: 250px;
    background-color: aliceblue;
    max-height: 400;
    overflow: auto;
}

table {
    border-collapse: collapse;
    font-size: small;
    cursor: pointer;
    user-select: none;
    width: 100%;
    background-color: rgba(245, 245, 245, 0.8);
}
#toolbar {
    --icon-color: black
}
#toolbar svg {
    fill: var(--icon-color);
}

#toolbar svg *[stroke] {
    stroke: var(--icon-color);
}

tr {
    height: 2em;
    border-collapse: collapse;
    border: 1px solid black;
}

    tr:hover {
        background-color: #cbe4fa80;
    }

    tr.select {
        background-color: #9bd0ff80;
    }

    tr td:first-child {
        font-family: "hmi";
        width: 2em;
        text-align: center;
    }

        tr td:first-child > span:before {
            content: "\\e907";
        }

td.ch:first-child > span:before {
    content: "\\e908";
}

tr td:nth-child(3) {
    text-align: end;
    padding-right: 0.5em;
}

tr td:last-child {
    width: 0.5em;
}

.btn {
    margin: 2px;
    align-items: center;
    justify-content: center;
    display: flex;
}

    .btn:hover {
        background-color: rgba(44, 111, 215, 0.04);
    }

    .btn.active {
        background-color: rgba(44, 111, 215, 0.32);
    }

    .btn.disable {
        color: lightgray;
        pointer-events: none;
    }

        .btn.disable.active {
            background-color: rgba(191, 191, 191, 0.32);
        }

[class^="hmi-j-"],
[class*=" hmi-j-"] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "hmi" !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    font-size: 24px;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
#toolbar [class^="hmi-j-"]::before,
[class*=" hmi-j-"]::before {
    color: var(--icon-color);
}

.hmi-j--allpage:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.hmi-j-step-down:before {
    content: "\\e909";
}

.hmi-j-step-up:before {
    content: "\\e90a";
}

.hmi-j-up-down:before {
    content: "\\e90b";
}

.hmi-j-find:before {
    content: "\\e90c";
}

.hmi-j-full-screen:before {
    content: "\\e90d";
}

.hmi-j-filter:before {
    content: "\\e90e";
}

.hmi-j-legend:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.hmi-j-pause:before {
    content: "\\e910";
}

.hmi-j-play:before {
    content: "\\e911";
}

.hmi-j-f-marker:before {
    content: "\\e912";
}

.hmi-j-e-marker:before {
    content: "\\e913";
}

.hmi-j-print:before {
    content: "\\e914";
}

.hmi-j-export:before {
    content: "\\e915";
}

.hmi-j-zoom-in:before {
    content: "\\e901";
}

.hmi-j-zoom-out:before {
    content: "\\e902";
}

.hmi-j-zoom-cancel:before {
    content: "\\e903";
}

.hmi-j-table:before {
    content: "\\e904";
}

.hmi-j-select-data:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.hmi-j-info:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.hmi-j-chk_empt:before {
    content: "\\e907";
}

.hmi-j-chk_sel:before {
    content: "\\e908";
}

.hmi-j-trend_legend:before {
    content: "\\e916";
}

.hmi-j-greed:before {
    content: "\\e917";
}

.hmi-j-f_page:before {
    content: "\\e918";
}

.hmi-j-p_page:before {
    content: "\\e919";
}

.hmi-j-n_page:before {
    content: "\\e91a";
}

.hmi-j-l_page:before {
    content: "\\e91b";
}

.hmi-j-expand:before {
    content: "\\e91c";
}

.hmi-j-tree:before {
    content: "\\e91d";
}

.hmi-j-setMark:before {
    content: "\\e91f";
}

.hmi-j-clearMark:before {
    content: "\\e920";
}

.hmi-j-delete:before {
    content: "\\e924";
}

.hmi-j-add:before {
    content: "\\e922";
}

.hmi-j-edit:before {
    content: "\\e923";
}

.hmi-j-reload:before {
    content: "\\e921";
}

.hmi-j-print_screen:before {
    content: "\\e925";
}

.hmi-j-reset_settings:before {
    content: "\\e926";
}

.hmi-j-inerval_mode:before {
    content: "\\e927";
}

.hmi-j-inerval_go:before {
    content: "\\e928";
}

.hmi-j-inerval_stop:before {
    content: "\\e929";
}

.hmi-j-saveNamedParams:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.hmi-j-loadNamedParams:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.hmi-j--ackall:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
`, "",{"version":3,"sources":["webpack://./src/controls/trend/trend.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;AACjC;;IAEI;;QAEI,kBAAkB;QAClB,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,SAAS;QACT,UAAU;QACV,WAAW;QACX,WAAW;QACX,iCAAiC;QACjC,8BAA8B;QAC9B,yBAAyB;QACzB,+CAA+C;QAC/C,4CAA4C;QAC5C,uCAAuC;IAC3C;;IAEA;QACI,SAAS;QACT,UAAU;QACV,UAAU;QACV,WAAW;QACX,iCAAiC;QACjC,8BAA8B;QAC9B,yBAAyB;QACzB,+CAA+C;QAC/C,4CAA4C;QAC5C,uCAAuC;IAC3C;;AAEJ;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,UAAU;IACV,0BAA0B,EAAE,sDAAsD;IAClF,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,QAAQ;IACR,aAAa;IACb,WAAW;IACX,eAAe;IACf,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,0CAA0C;AAC9C;AACA;IACI;AACJ;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,uBAAuB;AAC3B;;IAEI;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,kBAAkB;IACtB;;QAEI;YACI,gBAAgB;QACpB;;AAER;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;IAEI;QACI,0CAA0C;IAC9C;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;IACxB;;QAEI;YACI,2CAA2C;QAC/C;;AAER;;IAEI,+EAA+E;IAC/E,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;AACtC;AACA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,gDAA+b;AACnc;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gDAAqb;AACzb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gDAA6iB;AACjjB;;AAEA;IACI,gDAA2gB;AAC/gB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gDAA0rB;AAC9rB;;AAEA;IACI,gDAAqmB;AACzmB;;AAEA;IACI,gDAAkf;AACtf","sourcesContent":[".timerinterval-wrap {\r\n    position: relative;\r\n    z-index: 1000;\r\n    width: 100%;\r\n}\r\n\r\ndiv.preloader {\r\n    visibility: hidden;\r\n    opacity: 0;\r\n    position: absolute;\r\n    right: 0;\r\n    bottom: 0;\r\n    z-index: 100000000;\r\n    background: #8cc7eb;\r\n    pointer-events: none;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 6px;\r\n    transition: visibility 0s 0.2s, opacity 0.2s;\r\n}\r\n\r\n.preloader.show {\r\n    visibility: visible;\r\n    opacity: 0.8;\r\n    transition: visibility 0s 1s, opacity 0.3s 1s;\r\n}\r\n\r\n[data-loader=\"timer\"] {\r\n    position: relative;\r\n    width: 24px;\r\n    height: 24px;\r\n    border: 2px solid #fff;\r\n    border-radius: 50%;\r\n    background-color: transparent;\r\n}\r\n\r\n    [data-loader=\"timer\"]:after,\r\n    [data-loader=\"timer\"]:before {\r\n        position: absolute;\r\n        content: \"\";\r\n        background-color: #fff;\r\n    }\r\n\r\n    [data-loader=\"timer\"]:after {\r\n        top: 11px;\r\n        left: 11px;\r\n        width: 10px;\r\n        height: 2px;\r\n        -webkit-transform-origin: 1px 1px;\r\n        -moz-transform-origin: 1px 1px;\r\n        transform-origin: 1px 1px;\r\n        -webkit-animation: timerhand 2s linear infinite;\r\n        -moz-animation: timerhand 2s linear infinite;\r\n        animation: timerhand 2s linear infinite;\r\n    }\r\n\r\n    [data-loader=\"timer\"]:before {\r\n        top: 11px;\r\n        left: 11px;\r\n        width: 8px;\r\n        height: 2px;\r\n        -webkit-transform-origin: 1px 1px;\r\n        -moz-transform-origin: 1px 1px;\r\n        transform-origin: 1px 1px;\r\n        -webkit-animation: timerhand 8s linear infinite;\r\n        -moz-animation: timerhand 8s linear infinite;\r\n        animation: timerhand 8s linear infinite;\r\n    }\r\n\r\n@-webkit-keyframes timerhand {\r\n    0% {\r\n        -webkit-transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@-moz-keyframes timerhand {\r\n    0% {\r\n        -webkit-transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@-o-keyframes timerhand {\r\n    0% {\r\n        -webkit-transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@keyframes timerhand {\r\n    0% {\r\n        -webkit-transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n.trend {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: relative;\r\n}\r\n\r\n.trend__container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.trend__toolbar {\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 30px;\r\n}\r\n\r\n.trend__chart-wrapper {\r\n    position: relative;\r\n}\r\n\r\n.trend__chart {\r\n    position: relative;\r\n}\r\n\r\n.trend__minilegend {\r\n    position: absolute;\r\n    z-index: 1;\r\n    top: var(--top);\r\n    right: var(--right);\r\n}\r\n\r\n.trend__xdatazoom {\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    overflow: unset;\r\n    z-index: 1;\r\n    margin-left: var( --left ); /* чтобы зум начинался откуда же и график начинается */\r\n    width: 100%;\r\n    height: 20px;\r\n}\r\n\r\n.trend__ydatazoom {\r\n    box-sizing: border-box;\r\n    top: var(--top);\r\n    right: 0;\r\n    display: flex;\r\n    width: 20px;\r\n    overflow: unset;\r\n    z-index: 1;\r\n}\r\n\r\n.trend__minilegend .caption {\r\n    background: darkgray;\r\n    padding: 0.2em;\r\n    user-select: none;\r\n    cursor: all-scroll;\r\n}\r\n\r\n.legend {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 250px;\r\n    background-color: aliceblue;\r\n    max-height: 400;\r\n    overflow: auto;\r\n}\r\n\r\ntable {\r\n    border-collapse: collapse;\r\n    font-size: small;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    width: 100%;\r\n    background-color: rgba(245, 245, 245, 0.8);\r\n}\r\n#toolbar {\r\n    --icon-color: black\r\n}\r\n#toolbar svg {\r\n    fill: var(--icon-color);\r\n}\r\n\r\n#toolbar svg *[stroke] {\r\n    stroke: var(--icon-color);\r\n}\r\n\r\ntr {\r\n    height: 2em;\r\n    border-collapse: collapse;\r\n    border: 1px solid black;\r\n}\r\n\r\n    tr:hover {\r\n        background-color: #cbe4fa80;\r\n    }\r\n\r\n    tr.select {\r\n        background-color: #9bd0ff80;\r\n    }\r\n\r\n    tr td:first-child {\r\n        font-family: \"hmi\";\r\n        width: 2em;\r\n        text-align: center;\r\n    }\r\n\r\n        tr td:first-child > span:before {\r\n            content: \"\\e907\";\r\n        }\r\n\r\ntd.ch:first-child > span:before {\r\n    content: \"\\e908\";\r\n}\r\n\r\ntr td:nth-child(3) {\r\n    text-align: end;\r\n    padding-right: 0.5em;\r\n}\r\n\r\ntr td:last-child {\r\n    width: 0.5em;\r\n}\r\n\r\n.btn {\r\n    margin: 2px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    display: flex;\r\n}\r\n\r\n    .btn:hover {\r\n        background-color: rgba(44, 111, 215, 0.04);\r\n    }\r\n\r\n    .btn.active {\r\n        background-color: rgba(44, 111, 215, 0.32);\r\n    }\r\n\r\n    .btn.disable {\r\n        color: lightgray;\r\n        pointer-events: none;\r\n    }\r\n\r\n        .btn.disable.active {\r\n            background-color: rgba(191, 191, 191, 0.32);\r\n        }\r\n\r\n[class^=\"hmi-j-\"],\r\n[class*=\" hmi-j-\"] {\r\n    /* use !important to prevent issues with browser extensions that change fonts */\r\n    font-family: \"hmi\" !important;\r\n    speak: none;\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-variant: normal;\r\n    text-transform: none;\r\n    line-height: 1;\r\n    font-size: 24px;\r\n    /* Better Font Rendering =========== */\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n}\r\n#toolbar [class^=\"hmi-j-\"]::before,\r\n[class*=\" hmi-j-\"]::before {\r\n    color: var(--icon-color);\r\n}\r\n\r\n.hmi-j--allpage:before {\r\n    content: url(\"data:image/svg+xml;utf8,<svg version='1.1' id='Слой_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='18px' height='18px' viewBox='0 0 18 18' style='enable-background:new 0 0 18 18;' xml:space='preserve'><g>\t<g>\t\t<path d='M2,0v18h10.7l3.3-3.3V0H2z M15,14.3L12.3,17H12v-3h3V14.3z M15,13h-4v4H3V1h12V13z M13,3.7L12,3.3L9.3,9.6L5.9,6.1\t\t\tL5.1,6.9l4.5,4.5L13,3.7z'/>\t</g></g></svg>\");\r\n}\r\n\r\n.hmi-j-step-down:before {\r\n    content: \"\\e909\";\r\n}\r\n\r\n.hmi-j-step-up:before {\r\n    content: \"\\e90a\";\r\n}\r\n\r\n.hmi-j-up-down:before {\r\n    content: \"\\e90b\";\r\n}\r\n\r\n.hmi-j-find:before {\r\n    content: \"\\e90c\";\r\n}\r\n\r\n.hmi-j-full-screen:before {\r\n    content: \"\\e90d\";\r\n}\r\n\r\n.hmi-j-filter:before {\r\n    content: \"\\e90e\";\r\n}\r\n\r\n.hmi-j-legend:before {\r\n    content: url(\"data:image/svg+xml;utf8,<svg version='1.1' id='Слой_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='18px' height='18px' viewBox='0 0 18 18' style='enable-background:new 0 0 18 18;' xml:space='preserve'><g>\t<g>\t\t<path d='M2,0v18h10.7l3.3-3.3V0H2z M15,14.3L12.3,17H12v-3h3V14.3z M15,13h-4v4H3V1h12V13z M13,3H5v1h8V3z M13,6H5v1h8V6z M13,9H5\t\t\tv1h8V9z'/>\t</g></g></svg>\");\r\n}\r\n\r\n.hmi-j-pause:before {\r\n    content: \"\\e910\";\r\n}\r\n\r\n.hmi-j-play:before {\r\n    content: \"\\e911\";\r\n}\r\n\r\n.hmi-j-f-marker:before {\r\n    content: \"\\e912\";\r\n}\r\n\r\n.hmi-j-e-marker:before {\r\n    content: \"\\e913\";\r\n}\r\n\r\n.hmi-j-print:before {\r\n    content: \"\\e914\";\r\n}\r\n\r\n.hmi-j-export:before {\r\n    content: \"\\e915\";\r\n}\r\n\r\n.hmi-j-zoom-in:before {\r\n    content: \"\\e901\";\r\n}\r\n\r\n.hmi-j-zoom-out:before {\r\n    content: \"\\e902\";\r\n}\r\n\r\n.hmi-j-zoom-cancel:before {\r\n    content: \"\\e903\";\r\n}\r\n\r\n.hmi-j-table:before {\r\n    content: \"\\e904\";\r\n}\r\n\r\n.hmi-j-select-data:before {\r\n    content: url(\"data:image/svg+xml;utf8,<svg version='1.1' id='Слой_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='18px' height='18px' viewBox='0 0 18 18' style='enable-background:new 0 0 18 18;' xml:space='preserve'><g>\t<g>\t\t<path d='M11,6h-1v2h1V6z M8,6H7v2h1V6z M11,12h-1v2h1V12z M14,6h-1v2h1V6z M14,9h-1v2h1V9z M14,12h-1v2h1V12z M11,9h-1v2h1V9z\t\t\t M5,12H4v2h1V12z M8,9H7v2h1V9z M5,9H4v2h1V9z M15,3V1h-1v2H4V1H3v2H0v14h18V3H15z M17,16H1V4h16V16z M5,6H4v2h1V6z M8,12H7v2h1\t\t\tV12z'/>\t</g></g></svg> \");\r\n}\r\n\r\n.hmi-j-info:before {\r\n    content: url(\"data:image/svg+xml;utf8,<svg version='1.1' id='Слой_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='18px' height='18px' viewBox='0 0 18 18' style='enable-background:new 0 0 18 18;' xml:space='preserve'><g>\t<rect x='8.5' y='4' width='1' height='6'/>\t<path d='M9,1C4.6,1,1,4.6,1,9c0,4.4,3.6,8,8,8s8-3.6,8-8C17,4.6,13.4,1,9,1z M9,16c-3.9,0-7-3.1-7-7c0-3.9,3.1-7,7-7s7,3.1,7,7\t\tC16,12.9,12.9,16,9,16z'/>\t<rect x='8' y='12' width='2' height='1'/></g></svg>\");\r\n}\r\n\r\n.hmi-j-chk_empt:before {\r\n    content: \"\\e907\";\r\n}\r\n\r\n.hmi-j-chk_sel:before {\r\n    content: \"\\e908\";\r\n}\r\n\r\n.hmi-j-trend_legend:before {\r\n    content: \"\\e916\";\r\n}\r\n\r\n.hmi-j-greed:before {\r\n    content: \"\\e917\";\r\n}\r\n\r\n.hmi-j-f_page:before {\r\n    content: \"\\e918\";\r\n}\r\n\r\n.hmi-j-p_page:before {\r\n    content: \"\\e919\";\r\n}\r\n\r\n.hmi-j-n_page:before {\r\n    content: \"\\e91a\";\r\n}\r\n\r\n.hmi-j-l_page:before {\r\n    content: \"\\e91b\";\r\n}\r\n\r\n.hmi-j-expand:before {\r\n    content: \"\\e91c\";\r\n}\r\n\r\n.hmi-j-tree:before {\r\n    content: \"\\e91d\";\r\n}\r\n\r\n.hmi-j-setMark:before {\r\n    content: \"\\e91f\";\r\n}\r\n\r\n.hmi-j-clearMark:before {\r\n    content: \"\\e920\";\r\n}\r\n\r\n.hmi-j-delete:before {\r\n    content: \"\\e924\";\r\n}\r\n\r\n.hmi-j-add:before {\r\n    content: \"\\e922\";\r\n}\r\n\r\n.hmi-j-edit:before {\r\n    content: \"\\e923\";\r\n}\r\n\r\n.hmi-j-reload:before {\r\n    content: \"\\e921\";\r\n}\r\n\r\n.hmi-j-print_screen:before {\r\n    content: \"\\e925\";\r\n}\r\n\r\n.hmi-j-reset_settings:before {\r\n    content: \"\\e926\";\r\n}\r\n\r\n.hmi-j-inerval_mode:before {\r\n    content: \"\\e927\";\r\n}\r\n\r\n.hmi-j-inerval_go:before {\r\n    content: \"\\e928\";\r\n}\r\n\r\n.hmi-j-inerval_stop:before {\r\n    content: \"\\e929\";\r\n}\r\n\r\n.hmi-j-saveNamedParams:before {\r\n    content: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='18px' height='18px' fill='Black'><path d='M14,14v-1h-1v1H14z M16,14v-1h-1v1H16z M6,14v-1H5v1H6z M10,14v-1H9v1H10z M8,14v-1H7v1H8z M8.6,10h4l4.1-2.1l-0.4-0.8L12.4,9h-4l-4.1,2.1l0.4,0.8L8.6,10z M12,14v-1h-1v1H12z M14,1h-1v1h1V1z M16,1h-1v1h1V1z M12,1h-1v1h1V1z M8,1H7v1h1V1zM6,1H5v1h1V1z M8.6,6h4l4.1-2.1l-0.4-0.8L12.4,5h-4L4.3,7.1l0.4,0.8L8.6,6z M10,1H9v1h1V1z M4,3H3v1h1V3z M17,10h1V9h-1V10zM17,8h1V7h-1V8z M17,12h1v-1h-1V12z M17,14h1v-1h-1V14z M17,6h1V5h-1V6z M17,1v1h1V1H17z M17,4h1V3h-1V4z M4,7H3v1h1V7z M4,1H3v1h1V1z M4,5H3v1h1V5z M4,9H3v1h1V9z M4,13H3v1h1V13z M1,0H0v17h18v-1H1V0z M4,11H3v1h1V11z' /></svg>\");\r\n}\r\n\r\n.hmi-j-loadNamedParams:before {\r\n    content: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='18px' height='18px' fill='Black'><path d='M8,8V7H7v1H8z M8.6,4h4l4.1-2.1l-0.4-0.8L12.4,3h-4L4.3,5.1l0.4,0.8L8.6,4z M6,8V7H5v1H6z M16,14v-1h-1v1H16zM14,14v-1h-1v1H14z M8.6,11h4l4.1-2.1l-0.4-0.8L12.4,10h-4l-4.1,2.1l0.4,0.8L8.6,11z M10,8V7H9v1H10z M14,8V7h-1v1H14z M16,8V7h-1v1H16z M12,8V7h-1v1H12z M12,14v-1h-1v1H12z M1,0H0v17h18v-1H1V0z M4,13H3v1h1V13z M17,12h1v-1h-1V12z M17,14h1v-1h-1V14zM17,10h1V9h-1V10z M17,7v1h1V7H17z M8,14v-1H7v1H8z M10,14v-1H9v1H10z M4,11H3v1h1V11z M6,14v-1H5v1H6z M4,7H3v1h1V7z M4,9H3v1h1V9z' /></svg>\");\r\n}\r\n\r\n.hmi-j--ackall:before {\r\n    content: url(\"data:image/svg+xml;utf8,<svg version='1.1' id='Слой_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='18px' height='18px' viewBox='0 0 18 18' style='enable-background:new 0 0 18 18;' xml:space='preserve'><g>\t<polygon points='11,2.3 8.3,8.6 4.9,5.1 4.1,5.9 8.6,10.4 12,2.7 \t'/>\t<path d='M14,2V0H2v16h2v2h7.7l4.3-4.3V2H14z M3,1h10v10H9v4H3V1z M13,12v0.3L10.3,15H10v-3H13z M15,13.3L11.3,17H5v-1h5.7l3.3-3.3\t\tV3h1V13.3z'/></g></svg>\");\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
